import socketIO from 'socket.io-client';
import sailsIO from 'sails.io.js';
import store from 'app-store';
import _ from 'lodash';
import moment from 'moment';

// Actions
import { alerts, clearAlerts } from 'modules/alerts/actions';

const loadTime = moment();
const io = sailsIO(socketIO);

// Required config for multi endpoint
io.sails.transports = ['websocket'];

const socketListeners = {};
const socketReconnectCallbacks = {};

// If the socket disconnects, let the user know so they're not operating with out of date data
io.socket.on('disconnect', () => {
  alerts.error({ title: 'Server connection lost', subtitle: 'Refresh the page' });
});

// If the socket reconnects, reregister the socket listeners and let the user know they are connected again
io.socket.on('reconnect', reconnectAllSockets);

const debouncedReconnectAllSockets = _.debounce(reconnectAllSockets, 30 * 60 * 1000, { leading: true, trailing: false });

document.addEventListener('visibilitychange', () => {
  const isVisible = document.visibilityState === 'visible';
  const loadedRecently = moment().subtract(30, 'minutes').isBefore(loadTime);

  if (isVisible && !loadedRecently) debouncedReconnectAllSockets(true);
});

export function reconnectAllSockets(skipAlert) {
  _.forEach(socketListeners, (onSocketUpdate, socketName) => {
    registerSocket(socketName, onSocketUpdate, socketReconnectCallbacks[socketName], true); // Reregister all current socket listeners
  });
  
  clearAlerts();
  if (!skipAlert) alerts.success({ title: 'Reconnected to the server!', expires: 3 });
}

export function registerSocket(socketName, onSocketUpdate, onSocketReconnect, isReconnect) {
  io.socket.request({
    method: 'POST',
    url: '/api/socket/register',
    headers: { Authorization: `Bearer ${store.getState().auth.token}` },
    data: { socket: socketName }
  }, (resData) => {
    if (process.env.NODE_ENV !== 'production') console.log(`${socketName} socket: ${resData}`);
  });

  // Remember the socket listener so we can reregister it later if the socket reconnects
  socketListeners[socketName] = onSocketUpdate;

  // Remember the socket reconnect callback so we can call it later if the socket reconnects
  if (onSocketReconnect) {
    socketReconnectCallbacks[socketName] = onSocketReconnect;
    if (isReconnect) onSocketReconnect();
  }

  // Only bind the function on initial connect
  if (!isReconnect) {
    io.socket.on(socketName, data => {
      onSocketUpdate(data);
    });
  }
}

export function deregisterSocket(socketName) {
  io.socket.request({
    method: 'POST',
    url: '/api/socket/deregister',
    headers: { Authorization: `Bearer ${store.getState().auth.token}` },
    data: { socket: socketName }
  });

  delete socketListeners[socketName]; // Forget the registered socket listener so we don't reregister it later
  delete socketReconnectCallbacks[socketName]; // Forget the socket reconnect callback so we don't call it later
  io.socket.off(socketName);
}



// WEBPACK FOOTER //
// ./app/services/socket.js